import firstdp from '../assets/img/Frame 98.svg'
import twitterlogo from '../assets/img/Vector.svg'
const testimonies = [
    {
        index: 0,
        profilephoto: firstdp,
        name: 'Sarah M.',
        title: 'CEO of a cosmetics company',
        username: '@seary_ehm',
        socialmedialogo: twitterlogo,
        testimony: "I've been working with PackMate for several years now, and I have to say that I am thoroughly impressed with their quality of work. They provide the perfect packaging for my products, and the customer service is exceptional. I highly recommend this company to anyone looking for the best packaging solutions"
    }
]

export default testimonies